var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_camera@0.0x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C02",
    transform: "translate(-338.000000, -152.000000)",
    fill: "#51575C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(226.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device",
    transform: "translate(112.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_camera",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.934,3.73400001 L11.734,6.40000001 L11.734,9.60000001 L14.934,12.266 L16,12.266 L16,3.73400001 L14.934,3.73400001 L14.934,3.73400001 Z M1.3282,2.39999998 L9.8741,2.39999998 C10.2260575,2.39999998 10.5636211,2.53970656 10.8124833,2.78858747 C11.0613454,3.03746838 11.2010001,3.37504253 11.2010001,3.72700001 L11.2010001,12.273 C11.2010001,12.6249494 11.0613103,12.9625081 10.8124539,13.2113832 C10.5635975,13.4602584 10.2260494,13.6 9.8741,13.6 L1.3281,13.6 C0.976194489,13.6 0.638707956,13.4601787 0.389910694,13.2113065 C0.141113433,12.9624342 0.00149993961,12.6249055 0.00149993961,12.273 L0.00149993961,3.72700001 C0.00149993961,3.37508532 0.141162213,3.0375569 0.389975351,2.7886875 C0.63878849,2.5398181 0.976285298,2.39999998 1.3282,2.39999998 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.99f0a491d28b57076b41c1e814947be5.svg";
export { ForwardRef as ReactComponent };